import { render, staticRenderFns } from "./modal-board-delete-confirmation.vue?vue&type=template&id=db5cc1dc&"
import script from "./modal-board-delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./modal-board-delete-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./modal-board-delete-confirmation.vue?vue&type=style&index=0&id=db5cc1dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports